/* External */
import { useMemo } from 'react';

export default function useSortAndFilterChannels(channels, defaultOrder = false) {
  return useMemo(() => {
    const entitledChannels = channels?.filter(
      (channel) => channel.isEntitled,
    );

    if (defaultOrder) return entitledChannels;

    return entitledChannels?.sort(
      (channelA, channelB) => {
        const nameA = channelA.title.toLowerCase();
        const nameB = channelB.title.toLowerCase();

        if (nameA === nameB) return 0;

        return (nameA < nameB) ? -1 : 1;
      },
    );
  }, [channels, defaultOrder]);
}
